import { render, staticRenderFns } from "./FailedLinkData.vue?vue&type=template&id=50135251&"
import script from "./FailedLinkData.vue?vue&type=script&lang=js&"
export * from "./FailedLinkData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports